/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const startTrialDataSchema = z.object({
	paymentMethodId: z.string().uuid().nullable().optional(),
})

export type StartTrialDataSchema = z.infer<typeof startTrialDataSchema>
